import React, { useMemo, useContext, useState, createContext } from 'react'
import { useTranslation } from 'react-i18next'
import isEmpty from 'lodash/isEmpty'

import FloorBlock from './FloorBlock'
import { RestaurantContext } from 'sections/options/sections/RestaurantDesigner/RestaurantDesignerHandler'
import { ExpandableBlocks } from 'components/ContentBlock'
import FloorModal from './FloorModal'
import Button from 'components/Button'

export const FloorsContext = createContext()

const FloorsBlocksContainers = (props) => {
	const { currentProjectData, currentProjectIds } = useContext(RestaurantContext)
	const [showModal, setShowModal] = useState(false)
	const [modalFloor, setModalFloor] = useState(null)
	const [activeFloor, setActiveFloor] = useState(null)
	const [t] = useTranslation()

	useMemo(()=>{
		if(currentProjectData.floorData && currentProjectIds.floorId) {
			setActiveFloor(`${currentProjectData.floorData.number}`)
		}
	}, [currentProjectData.floorData && currentProjectData.floorData.number])

	useMemo(()=> {
		if(modalFloor && !showModal) {
			setShowModal(true)
		}
	}, [modalFloor, showModal])
	return (
		<FloorsContext.Provider value={{ showModal, setShowModal, setModalFloor }}>
			{
				!isEmpty(currentProjectData.projectData.floors) ? (
					<ExpandableBlocks expandedId={currentProjectIds.floorId ? activeFloor : null} onExpand={setActiveFloor} nested >
						{currentProjectData.projectData.floors.map((floorItem, floorKey) => <FloorBlock key={floorItem.id} {...{ activeFloor, floorItem, floorKey }} {...props} />)}
					</ExpandableBlocks>
				) : <div/>
			}
			{
				modalFloor && <FloorModal key={modalFloor} floorItem={modalFloor} {...props} />
			}
			<Button style={{ width: '220px', marginTop: '20px' }} onClick={()=>{
				setModalFloor({})
				setShowModal(true)
			}} status={'green'} text={t('restaurant_designer_section.buttons.add_new_floor')}/>

		</FloorsContext.Provider>
	)
}

export default FloorsBlocksContainers
